import React, { useEffect, useState } from 'react';

import Modal from '../common/Modal';
// Import the CSS file for styling

import { useVoiceApi } from '../../auth/helper/api/voiceApi';

const VoiceTemplateVariablePage = () => {



  const voiceApi = useVoiceApi();
  const [templateVariables, setTemplateVariables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false); // State for modal visibility
  const [newTemplateVariable, setNewTemplateVariable] = useState({
    templateVariableName: '',
    templateVariableDesc: '',
    templateVariableDefaultValue: '',
    status: true, // Default value
  });
  const [editingTemplateVariable, setEditingTemplateVariable] = useState(null); // Track which template variable is being edited
  const [editDescription, setEditDescription] = useState(''); // Track edited description
  const [editDefaultValue, setEditDefaultValue] = useState(''); // Track edited default value

  // State for filters
  const [filters, setFilters] = useState({
    id: null,
    templateVariableName: '',
    templateVariableDefaultValue: '',
    status: true, // Default value  
  });

  //for handling pagination
  const [page, setPage] = useState(0); // Starting from the first page
  const [size, setSize] = useState(3); // Number of items per page
  const [totalPages, setTotalPages] = useState(0); // To store total pages


  useEffect(() => {

    const fetchTemplateVariables = async () => {
      try {
        const response = await voiceApi.get(
          process.env
            .REACT_APP_GET_ALL_VOICE_TEMPLATE_VARIABLES_BY_PAGE_ENDPOINT,
          {
            params: {
              ...filters,
              page,
              size,
            },
          }
        );
        // Extract data from the response
        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) { // Check for successful status
          setTemplateVariables(object.content); // Set the templates from the response object
          setTotalPages(object.totalPages);
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }

        setLoading(false);
      } catch (err) {
        console.error('Error fetching templateVariables:', err);
        setError(err.message || 'An error occurred.');
        setLoading(false);

      }
    };

    fetchTemplateVariables();
  }, [voiceApi, page, size]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewTemplateVariable((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditClick = (templateVariable) => {
    // Set the template being edited
    setEditingTemplateVariable(templateVariable.id);
    setEditDescription(templateVariable.templateVariableDesc); // Set the description to edit
    setEditDefaultValue(templateVariable.templateVariableDefaultValue); //set the default vaule to edit
  };

  const handleEditSubmit = async (templateVariableId) => {

    try {
      // Update template variable with PUT request

      await voiceApi.put(
        `${process.env.REACT_APP_PUT_VOICE_TEMPLATE_VARIABLE_ENDPOINT}/${templateVariableId}`,
        {
          templateVariableDesc: editDescription, // the description field is updated
          templateVariableDefaultValue: editDefaultValue, // the default value is updated
        }
      );

      // Refresh the templateVariables list after the update
      const updatedTemplateVariables = templateVariables.map((templateVariable) => {
        if (templateVariable.id === templateVariableId) {
          return { ...templateVariable, templateVariableDesc: editDescription, templateVariableDefaultValue: editDefaultValue }; // Update the edited template variable
        }
        return templateVariable; // Keep the other records unchanged
      });
      setTemplateVariables(updatedTemplateVariables);
      setEditingTemplateVariable(null); // Reset editing state
      setEditDescription(''); // Clear edit description 
      setEditDefaultValue(''); //clear
    } catch (err) {
      setError(err.message || 'An error occurred while updating the Template variable.');
    }
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    try {
      const response = await voiceApi.post(
        `${process.env.REACT_APP_SET_VOICE_TEMPLATE_VARIABLE_ENDPOINT}`,
        newTemplateVariable
      );
      if (response.status === 200) {
        setTemplateVariables((prev) => [...prev, response.data.object]); // Update with new templateVariable
        setNewTemplateVariable({
          templateVariableName: '',
          templateVariableDesc: '',
          templateVariableDefaultValue: '',
          status: true, // Default value
        });
        setError(null);
        setModalOpen(false); // Close modal after submission
      } else {
        setError(`Error: ${response.data.message}`);
      }
    } catch (err) {
      setError(err.message || 'An error occurred while creating the templateVariable.');
    }
  };

  const handleFilterInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => {
      const newFilters = { ...prev, [name]: value };
      return newFilters;
    });
  };

  // Handle the status change to convert to boolean
  const handleStatusChange = (e) => {
    const value = e.target.value;
    const statusValue = value === 'Active' ? true : value === 'Inactive' ? false : null;

    setFilters((prev) => {
      const newFilters = { ...prev, status: statusValue };
      return newFilters;
    });
  };

  const toggleActivationStatus = async (templateVariableId, currentStatus) => {

    try {
      const newStatus = !currentStatus; // Toggle the current status
      await voiceApi.patch(
        `${process.env.REACT_APP_SET_VOICE_TEMPLATE_VARIABLE_STATUS_ENDPOINT}/${templateVariableId}`,
        { status: newStatus }
      );
      setTemplateVariables((prev) =>
        prev.map((templateVariable) => templateVariable.id === templateVariableId ? { ...templateVariable, status: newStatus } : templateVariable)
      );
    } catch (err) {
      setError(err.message || 'An error occurred while updating the status.');
    }
  };

  // New function to apply filters
  const applyFilters = async () => {

    setLoading(true); // Show loading while fetching filtered notifications
    try {

      const response = await voiceApi.get(
        process.env
          .REACT_APP_GET_ALL_VOICE_TEMPLATE_VARIABLES_BY_PAGE_ENDPOINT,
        {
          params: {
            ...filters,
            page,
            size,
          },
        }
      );
      // Extract data from the response
      const { message, object, httpStatus } = response.data;

      if (httpStatus === 200) { // Check for successful status
        setTemplateVariables(object.content); // Set the templates from the response object
        setTotalPages(object.totalPages);
      } else {
        setError(`Error: ${message}`); // Handle non-success status code
      }

      setLoading(false);
    } catch (err) {
      console.error('Error fetching templateVariables:', err);
      setError(err.message || 'An error occurred.');
      setLoading(false);

    }
  };

  const handleNextPage = () => {
    if (page + 1 < totalPages) {
      setPage((prevPage) => prevPage + 1); // Increment page number
    }
  };

  const handlePreviousPage = () => {
    if (page > 0) {
      setPage((prevPage) => prevPage - 1); // Decrement page number
    }
  };

  const handleSizeChange = (e) => {
    setSize(e.target.value);
    setPage(0); // Reset to first page on changing size
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="template-variable-container">
      <h2>Voice Template Variables</h2>
      <div className="flex-row filter-section">
        <div className='filter-item'>
          <label htmlFor="items-per-page">Items per page: </label>
          <select id="items-per-page" onChange={handleSizeChange} className="w-auto">
            <option value={3}>default</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={5}>5</option>
            <option value={10}>10</option>
          </select>
        </div>
      </div>

      <h3>Filters</h3>
      {/* Filter Form */}
      <div className="flex-row filter-section">
        <div className="filter-item">
          <label>Id:</label>
          <input
            type="text"
            name="id"
            value={filters.id ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>Name:</label>
          <input
            type="text"
            name="templateVariableName"
            value={filters.templateVariableName ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>Value:</label>
          <input
            type="text"
            name="templateVariableDefaultValue"
            value={filters.templateVariableDefaultValue ?? ''}
            onChange={handleFilterInputChange}
          />
        </div>

        <div className="filter-item">
          <label>Status:</label>
          <select name="status" onChange={handleStatusChange} value={filters.status === null ? '' : filters.status ? 'Active' : 'Inactive'}>
            <option value="">All</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        <button type="button" onClick={applyFilters}>Apply Filters</button>

      </div>

      {/* Button to open the modal */}
      <button onClick={() => setModalOpen(true)}>+ Create New</button>

      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
        <div className="page-container">
          <h3>Create New Voice Template Variable</h3>
          <form onSubmit={handleSubmit} className="standard-form">

            <div className="form-group">
              <label>Name:</label>
              <input
                type="text"
                name="templateVariableName"
                value={newTemplateVariable.templateVariableName}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Description:</label>
              <input
                type="text"
                name="templateVariableDesc"
                value={newTemplateVariable.templateVariableDesc}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Default value:</label>
              <input
                type="text"
                name="templateVariableDefaultValue"
                value={newTemplateVariable.templateVariableDefaultValue}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Activation Status:</label>
              <input
                type="checkbox"
                name="status"
                checked={newTemplateVariable.status}
                onChange={handleInputChange}
              />
            </div>

            <button type="submit">Create Category</button>
          </form>
        </div>
      </Modal>

      <h3>Existing Voice Template Variables</h3>
      {templateVariables.length === 0 ? (
        <p>No Template Variables available</p>
      ) : (
        <div className="table-responsive">
          <table className="notifications-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Description</th>
                <th>Default</th>
                <th>Created At</th>
                <th>Status</th>
                <th>Last Updated At</th>
                <th>Last Updated By</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {templateVariables.map((templateVariable) => (
                <tr key={templateVariable.id}>
                  <td>{templateVariable.id}</td>
                  <td>{templateVariable.templateVariableName}</td>
                  <td>
                    {editingTemplateVariable === templateVariable.id ? (
                      <input
                        type="text"
                        value={editDescription}
                        onChange={(e) => setEditDescription(e.target.value)} // Handle edit description change
                      />
                    ) : (
                      templateVariable.templateVariableDesc
                    )}
                  </td>
                  <td>
                    {editingTemplateVariable === templateVariable.id ? (
                      <input
                        type="text"
                        value={editDefaultValue}
                        onChange={(e) => setEditDefaultValue(e.target.value)} // Handle edit default value change
                      />
                    ) : (
                      templateVariable.templateVariableDefaultValue
                    )}
                  </td>
                  <td>{new Date(templateVariable.createdTimestamp).toLocaleString()}</td>
                  <td>{templateVariable.status ? 'Active' : 'Inactive'}</td>
                  <td>{new Date(templateVariable.updatedTimestamp).toLocaleString()}</td>
                  <td>{templateVariable.lastUpdatedBy}</td>
                  <td>
                    <div className="action-buttons">
                      {editingTemplateVariable === templateVariable.id ? (
                        <button onClick={() => handleEditSubmit(templateVariable.id)}>Save</button> // Save edited voice template variable
                      ) : (
                        <button onClick={() => handleEditClick(templateVariable)}>Edit</button> // Set voice template variable to edit
                      )}
                      <button onClick={() => toggleActivationStatus(templateVariable.id, templateVariable.status)}>
                        {templateVariable.status ? 'Disable' : 'Enable'}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Pagination Controls */}
      <div className="pagination-container">
        <button onClick={handlePreviousPage} disabled={page === 0}>Previous</button>
        <span>Page {page + 1} of {totalPages}</span>
        <button onClick={handleNextPage} disabled={page + 1 === totalPages}>Next</button>
      </div>
    </div>
  );
};

export default VoiceTemplateVariablePage;
